/**
 * MJ 悠船 V8（midjourney-v8）manifest
 * 数据来源：image.json field_map
 * 特点：与 V7 同构（参数取值一致），仅模型 ID 与显示名不同
 */
import type { ImageModelConfig } from '../../types';

export const mjYouchuanV8: ImageModelConfig = {
  id: '01M24G4QHVHAJE6KNXHCTAFDDV',
  displayName: 'MJ 悠船 V8',

  defaults: {
    ratio: '1:1', // 接口 select: true 项
    raw: 0, // 接口 raw.value
    changeDegree: 30, // 接口 change_degree.value
    stylize: 100, // 接口 stylize.value
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1' },
      { label: '2:3', value: '2:3' },
      { label: '3:2', value: '3:2' },
      { label: '3:4', value: '3:4' },
      { label: '4:3', value: '4:3' },
      { label: '9:16', value: '9:16' },
      { label: '16:9', value: '16:9' },
      { label: '21:9', value: '21:9' },
    ],
  },

  resolutionOptions: [],
  qualityOptions: [],

  toggles: {
    changeDegree: true, // 变化度滑杆（0~100，step 10）
    stylize: true, // 风格化滑杆（0~1000，step 10）
    raw: true, // 原始模式单选（0=常规 / 1=原始）
  },

  limits: {
    maxRefImages: 6, // 接口 field_map.ref_images.max
  },
};
